import { render } from "./Navigation.vue?vue&type=template&id=b5d4f812&scoped=true"
const script = {}

import "./Navigation.vue?vue&type=style&index=0&id=b5d4f812&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d4f812"]])

export default __exports__